
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
    }
  },
  methods: {
    verifyScrollability() {
      const scrollableArea = this.$refs.scrollableArea as HTMLElement
      this.canScrollLeft = scrollableArea.scrollLeft > 0
      this.canScrollRight =
        scrollableArea.scrollLeft + scrollableArea.clientWidth <
        scrollableArea.scrollWidth
    },
    scrollLeft() {
      const scrollableArea = this.$refs.scrollableArea as HTMLElement
      scrollableArea.scrollBy({
        left: -scrollableArea.clientWidth,
        behavior: 'smooth',
      })
    },

    scrollRight() {
      const scrollableArea = this.$refs.scrollableArea as HTMLElement
      scrollableArea.scrollBy({
        left: scrollableArea.clientWidth,
        behavior: 'smooth',
      })
    },
  },

  mounted() {
    this.verifyScrollability()
    window.addEventListener('resize', this.verifyScrollability)
  },
  destroyed() {
    window.removeEventListener('resize', this.verifyScrollability)
  },
})
